
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio",
      function () {
        return require("private-next-pages/portfolio/index.js");
      }
    ]);
  